<template>
  <div id="category-panel" class="h-100">
    <div class="category-grid" ref="categoryGrid" v-on:scroll="handleScroll">
      <button class="category" @click="fastLineOrBack">
        <span class="category-name">{{ category ? 'Back' : 'Fast Line' }}</span>
      </button>

      <button class="category" v-for="category in selectedCategories" @click="selectCategory(category.name)">
        <span class="category-name">{{ category.name }}</span>
      </button>
    </div>
    <div class="scroll-controls" v-if="isScrollable">
      <button class="scroll-control" @click="scrollToTop">
        <font-awesome-icon :icon="['fas', 'chevron-up']" />
      </button>
      <button class="scroll-control" @click="scrollToBottom">
        <font-awesome-icon :icon="['fas', 'chevron-down']" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductCategories',
  components: {},
  props: {
    showMainCategories: {
      type: Function,
      required: false
    }
  },
  computed: {
    categorySearch() {
      return this.$store.getters.getSearchCategories
    },
    categories() {
      return this.$store.getters.getCategories
    },
    selectedCategories() {
      if (this.category && this.subCategory) {
        let main = this.categories
            .find(category => category.name.localeCompare(this.category, undefined, {sensitivity: 'base'}) === 0)
        let sub = main.children
            .find(category => category.name.localeCompare(this.subCategory, undefined, {sensitivity: 'base'}) === 0)
        if (!sub || sub.length === 0) {
          return main.children
        }
        return sub.children || []
      } else if (this.category) {
        return this.categories
            .find(category => category.name.localeCompare(this.category, undefined, {sensitivity: 'base'}) === 0)
            .children
      } else {
        return this.categories
      }
    },
  },
  data() {
    return {
      category: undefined,
      subCategory: undefined,
      subSubCategory: undefined,
      isScrollable: false,
      scrollPosition: 0,
      maxScrollTop: 0
    }
  },
  mounted() {
    this.searchProducts()
  },
  methods: {
    clearCategory() {
      this.category = undefined
      this.subCategory = undefined
      this.subSubCategory = undefined
      this.searchProducts()
    },
    selectMainCategory() {
      this.$store.commit(`setLimit`, 30)
      this.subSubCategory = undefined
      this.subCategory = undefined
      this.searchProducts()
    },
    selectSubCategory() {
      this.$store.commit(`setLimit`, 30)
      this.subCategory = undefined
      this.searchProducts()
    },
    selectCategory(category) {
      this.$store.commit(`setLimit`, 30)
      if (this.category && this.subCategory) {
        this.subSubCategory = category
      } else if (this.category) {
        this.subCategory = category
      } else {
        this.category = category
      }

      this.showCategories()
      this.searchProducts()
    },
    showCategories() {
      let show = this.showMainCategories
      if (show) {
        show(false)
      }
    },
    searchProducts() {
      if (this.category) {
        let searchQuery = {
          category: this.category || '',
          subCategory: this.subCategory || '',
          sub2Category: this.subSubCategory || '',
        };
        this.$store.commit(`setSearchCategories`, searchQuery)
        this.$store.dispatch('searchStock', searchQuery)
      } else {
        this.$store.dispatch('getFastLine')
      }
    },
    fastLineOrBack() {
      if (this.category && this.subCategory && this.subSubCategory) {
        this.subSubCategory = undefined
      } else if (this.category && this.subCategory) {
        this.subCategory = undefined
      } else {
        this.category = undefined
      }
      this.showCategories()
      this.searchProducts()
    },
    scrollToTop() {
      const newScrollTop = Math.max(this.scrollPosition - 110, 0);
      this.$refs.categoryGrid.scrollTo({
        top: newScrollTop,
        behavior: 'smooth',
      });
    },
    scrollToBottom() {
      const newScrollTop = Math.min(this.scrollPosition + 110, this.maxScrollTop);
      this.$refs.categoryGrid.scrollTo({
        top: newScrollTop,
        behavior: 'smooth',
      });
    },
    handleScroll() {
      const scroll = {
        scrollTop: this.$refs.categoryGrid.scrollTop,
        scrollHeight: this.$refs.categoryGrid.scrollHeight,
        clientHeight: this.$refs.categoryGrid.clientHeight
      }
      this.scrollPosition = scroll.scrollTop
      this.maxScrollTop = scroll.scrollHeight - scroll.clientHeight
      this.isScrollable = scroll.scrollHeight > scroll.clientHeight;
    },
  },
}
</script>

<style lang="scss" scoped>
#category-panel {
  padding: 0 5px 0 0;
  display: flex;
  flex-direction: column;
  position: relative;

  .scroll-controls {
    position: absolute;
    bottom: 2vh;
    right: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
    .scroll-control {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background-color: rgba(59, 130, 246, 0.2);
      color: #3b82f6;
    }
  }

  .title {
    font-size: 1.5rem;
    margin: 0 0 10px 0;
    text-align: center;
  }

  .category-breadcrumbs {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    .clear-btn {
      color: #40434A;
      background: transparent;
      width: 30px;
      height: 30px;
    }
  }

  .category-grid {
    overflow-y: auto;
    overflow-x: hidden;
    display: grid;
    gap: 0.5em;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: auto;
    //border-top: 1px solid #c2c2c2;
    padding: 10px 10px 50px;
    height: calc(100vh - 150px);

    .category {
      height: 55px; /* Reduced height */
      width: 100%;
      background: none;
      display: flex;
      flex-direction: column;
      justify-content: center; /* Center the text vertically */
      align-items: center; /* Center the text horizontally */
      padding: 8px;
      box-sizing: border-box;
      position: relative;
      border: 1px solid #ddd;
      border-radius: 8px;
      background-color: #f9f9f9;
      transition: background-color 0.3s ease;

      &:hover {
        background-color: #e0e0e0;
      }

      .category-name {
        font-size: 14px;
        font-weight: 600;
        color: #303030;
        word-wrap: break-word;
        text-align: center;
        line-height: 1.2;
        max-width: 100%;
        overflow: hidden;
        white-space: normal;
        word-break: break-word;
        margin-bottom: 5px;
      }
    }
  }

  /* Mobile responsive styling */
  @media (max-width: 768px) {
    .category-grid {
      grid-template-columns: repeat(2, 1fr); /* 2 categories per row on medium screens */
    }
  }

  @media (max-width: 480px) {
    .category-grid {
      grid-template-columns: 1fr; /* 1 category per row on small screens */
    }

    .title {
      font-size: 1.2rem; /* Smaller title on mobile */
    }

    .category-name {
      font-size: 12px; /* Smaller text on mobile */
    }

    .category {
      height: 90px; /* Reduced category height for small screens */
    }
  }
}
</style>
